var _excluded = ["size", "type", "disabled", "value", "onChange", "onValueChange", "children", "className", "minWidth", "variant"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useCallback } from 'react';
import { classnames } from '@okee-uikit/react-utils';
import { useCombineCallback } from '@okee-uikit/react-hooks';
import { usePrefixCls } from '@okee-uikit/react-config';
import { RcGroup } from '../../hooks/group';
import { Button } from '../button';
import { RadioGroupButton } from './Button';
import { RadioGroupRadio } from './Radio';
import { RadioGroupTag } from './Tag';
import { RadioGroupFilled } from './Filled';
import { VariantContext } from './context/variant';
export function RadioGroup(props) {
  var _props$size = props.size,
      size = _props$size === void 0 ? 'md' : _props$size,
      _props$type = props.type,
      type = _props$type === void 0 ? 'radio' : _props$type,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      value = props.value,
      onChange = props.onChange,
      onValueChange = props.onValueChange,
      children = props.children,
      className = props.className,
      minWidth = props.minWidth,
      variant = props.variant,
      extra = _objectWithoutProperties(props, _excluded);

  var handleChange = useCombineCallback(onChange, onValueChange);
  var onGroupChange = useCallback(function (nv) {
    handleChange(nv.length === 0 ? undefined : nv[0]);
  }, []);
  var cls = classnames(usePrefixCls('radio-group', {
    type: type,
    size: size,
    disabled: disabled,
    variant: !!(variant === null || variant === void 0 ? void 0 : variant.length)
  }), className);
  return React.createElement(RcGroup, _objectSpread(_objectSpread({}, extra), {}, {
    className: cls,
    disabled: disabled,
    extraProps: {
      size: size,
      type: type
    },
    value: value == null ? [] : [value],
    onChange: onGroupChange,
    minWidth: minWidth
  }), React.createElement(VariantContext.Provider, {
    value: {
      variant: variant
    }
  }, type === 'button' ? React.createElement(Button.Group, null, children) : children));
}
RadioGroup.Radio = RadioGroupRadio;
RadioGroup.Button = RadioGroupButton;
RadioGroup.Tag = RadioGroupTag;
RadioGroup.Filled = RadioGroupFilled;